import { html } from "lit-html"

const inactiveCls = "text-gray-450"
const activeCls =
  "text-black underline underline-offset-[12px] decoration-yellow"

const HeadlineToggle = ({
  section,
  defaultLabel,
  altLabel,
  altSort,
  onToggle,
}) => html`
  ${defaultLabel && altLabel
    ? html`
        <div
          data-section="${section}"
          class="flex flex-wrap items-center text-xl lg:text-3xl"
        >
          <button
            class="${altSort
              ? inactiveCls
              : activeCls} mr-8 lg:mr-11 cursor-pointer font-serif"
            type="button"
            aria-pressed="${!altSort}"
            @click=${() => (altSort ? onToggle(false) : null)}
          >
            ${defaultLabel}
          </button>
          <button
            class="${altSort
              ? activeCls
              : inactiveCls} cursor-pointer font-serif"
            type="button"
            aria-pressed="${altSort}"
            @click=${() => (altSort ? null : onToggle(true))}
          >
            ${altLabel}
          </button>
        </div>
      `
    : ``}
`

export default HeadlineToggle
